// extracted by mini-css-extract-plugin
export var dropdown = "_je-0";
export var imagePlaceholder = "_je-2";
export var imageWrapper = "_je-3";
export var productImage = "_je-1";
export var truncateContainer = "_je-4";
export var truncateText = "_je-5";